// extracted by mini-css-extract-plugin
export default {"Activate":"Deactivate_Activate__eK70+"};